import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'
import {
  Container,
  List,
  Emp,
  ContainerDivs,
  DivAddEmp,
  AddEmp,
  DivDados,
  Grade,
  //SpanTotalGrade,
  //SpanGradeStudent,
  //SpanAverageGrade,
  SpanNameMatter,
  DadosStdt,
  ToGoBack,
  SignMessageButtonText,
  SignMessageButtonTextBold,
  PrintButton,
  SpanFrequency,
  DivBimTable,
  DivBimRow,
  DivBimHeader,
  DivBimCell,
  DivNameMatter,
  DivSignatureArea,
  SignatureBlock,
  Line,
  Label,
  Preview,
  ContLogo,
  InfoContainer,
  UpContainer
} from './style';

import GlobalStyle from './style';

import {
  GetNumGrade,
  AttendanceBimonthly,
  indexNumericalGradesCard,
  GetLogo,
  getIstQuarter,
  getIIndQuarter,
  fetchLogo,
  clssInfo,
  GetMatter
} from '../../Api';

import { IoCheckmarkSharp, IoCloseSharp } from "react-icons/io5";

import { FcSurvey } from "react-icons/fc";

import { useNavigate } from 'react-router-dom';

import LoadingSpinner from '../../components/Loading';
import { NotaComRec, LegendaNotas, useRecuperacoes } from '../../components/Recuperacao';

const GradeIstquarter = () => {

  const navigate = useNavigate()
  const [loading, setLoading] = useState(true);
  const [logo, setLogo] = useState([])
  const [grade, setGrade] = useState([])
  const [stdtName, setStdtName] = useState([])
  const [teacherName, setTeacherName] = useState('')
  const [nameSchool, setNameSchool] = useState('')
  const [logoUrl, setLogoUrl] = useState('');
  const [matters, setMatter] = useState([]);
  const [id_teacher, setId_teacher] = useState('')
  const [id_student, setid_student] = useState('')

  const [totalGrade, setTotalGrade] = useState([]);
  const [averageGrade, setAverageGrade] = useState([]);

  const [totalGradeIst, setTotalGradeIst] = useState([]);
  const [averageGradeIst, setAverageGradeIst] = useState([]);
  const [totalGradeIInd, setTotalGradeIInd] = useState([]);
  const [averageGradeIInd, setAverageGradeIInd] = useState([]);

  const [startd, setStartd] = useState('')
  const [startm, setStartm] = useState('')
  const [starty, setStarty] = useState('')
  const [endd, setEndd] = useState('')
  const [endm, setEndm] = useState('')
  const [endy, setEndy] = useState('')


  const [highlightedDays, setHighlightedDays] = React.useState([]);
  const [highlightedDaysF, setHighlightedDaysF] = React.useState([]);
  const [highlightedDaysFJ, setHighlightedDaysFJ] = React.useState([]);

  const [iStQuarter, setiStQuarter] = useState([]);
  const [iiNdQuarter, setiiNdQuarter] = useState([]);

  const [dataCla$$, setdataClass] = useState([]);

  const { idClass } = useParams();

  // recuperações lançadas para este aluno nesta turma (mostra 'Rec=' e a cor pela nota final)

  const { recFinal } = useRecuperacoes({ id_class: idClass, id_student: sessionStorage.getItem('StudentInformation') });

  const [assessmentRegime, setAssessmentRegime] = useState('');

  useEffect(() => {
    (async () => {
      setLoading(true);


      setAssessmentRegime(sessionStorage.getItem('assessmentRegime'))
      const resClass = await clssInfo(idClass);
      setdataClass(resClass)
      const $yearClass = resClass.data.data.find(clss => {
        return clss.year
      })
      const year = $yearClass.year
      const idSchool = JSON.parse(sessionStorage.getItem("id-school"));

      // matérias da escola na ordem do usuário (EF no fim)
      try {
        const resMatter = await GetMatter(idSchool);
        const EF_NAME = 'EDUCAÇÃO FÍSICA';
        const nrm = (s = '') => s.trim().toUpperCase();
        const rawMatters = resMatter.data.data || [];
        const orderedMatters = [...rawMatters].sort((a, b) => {
          const aEF = nrm(a.name) === EF_NAME;
          const bEF = nrm(b.name) === EF_NAME;
          if (aEF) return 1;
          if (bEF) return -1;
          return 0;
        });
        setMatter(orderedMatters);
      } catch (e) {
        console.error('Erro ao buscar matérias:', e);
      }

      const IstQuarter = await getIstQuarter(year, idSchool)
      const tgIst = await IstQuarter.data.data.map(res => {
        return res.totalGrade
      })
      const agIst = await IstQuarter.data.data.map(res => {
        return res.averageGrade
      })
      setTotalGradeIst(tgIst)
      setAverageGradeIst(agIst)

      const IIndQuarter = await getIIndQuarter(year, idSchool)
      const tgIInd = await IIndQuarter.data.data.map(res => {
        return res.totalGrade
      })
      const agIInd = await IIndQuarter.data.data.map(res => {
        return res.averageGrade
      })
      setTotalGradeIInd(tgIInd)
      setAverageGradeIInd(agIInd)

      const bimonthly = '3º BIMESTRE'
      const id_student = sessionStorage.getItem("StudentInformation");
      const nameSchool = sessionStorage.getItem("School");
      const stdtName = sessionStorage.getItem("stdt-name");
      const idlogo = sessionStorage.getItem("id_logo");
      setStdtName(stdtName)
      setNameSchool(nameSchool)
      setid_student(id_student)

      if (idlogo && /^[0-9a-fA-F]{24}$/.test(idlogo)) {
        const logo = await GetLogo(idlogo);
        if (logo?.data?.Logo?.url) {
          console.log('getlogo', logo.data.Logo.url);
          setLogo(logo.data.Logo.url);
        }
      } else {
        console.error("idlogo inválido:", idlogo);
      }

      const resGrade = await GetNumGrade(year, bimonthly, id_student)
      setGrade(resGrade.data.data)
      console.log("resGrade", resGrade.data.data)

      if (resGrade.data.data) {
        const idTeacher = resGrade.data.data.map(res => {
          return res.id_class.classRegentTeacher
        })
        const Teacher = idTeacher[0];
        //setId_teacher(Teacher)
        console.log("idTeacher", Teacher)
      }

      if (year && id_student) {
        const grades = await indexNumericalGradesCard(year, id_student)
        if (grades) {
          console.log("grades", grades.data.data);

          // Filtra os objetos para cada bimestre
          const firstQuarter = grades.data.data.filter(res => res.bimonthly === "1º BIMESTRE");
          const secondQuarter = grades.data.data.filter(res => res.bimonthly === "2º BIMESTRE");
          //const thirdQuarter = grades.data.data.filter(res => res.bimonthly === "3º BIMESTRE");
          //const fourthQuarter = grades.data.data.filter(res => res.bimonthly === "4º BIMESTRE");

          // Atualiza os estados com os arrays filtrados
          setiStQuarter(firstQuarter);
          setiiNdQuarter(secondQuarter);
          //setIIIrdQuarter(thirdQuarter)
          //setIVthQuarter(fourthQuarter)

          //console.log("1º Bimestre", firstQuarter);
          //console.log("2º Bimestre", secondQuarter);
        }
      }

      if (resGrade) {
        const allGrades = resGrade.data.data;

        // Verifica se há pelo menos uma matéria com o nome "EDUCAÇÃO FÍSICA"
        const hasPE = allGrades.some(res => res.id_matter.name === "EDUCAÇÃO FÍSICA");

        // Se tiver, move para o final; senão, mantém a ordem original
        const sortedResGrade = hasPE
          ? [
            ...allGrades.filter(res => res.id_matter.name !== "EDUCAÇÃO FÍSICA"),
            ...allGrades.filter(res => res.id_matter.name === "EDUCAÇÃO FÍSICA"),
          ]
          : allGrades;

        const tchr = sortedResGrade.map(res => res.id_teacher.name);
        const idTchr = sortedResGrade.map(res => res.id_teacher._id);
        setId_teacher(idTchr[0]);
        const firstTeacher = tchr[0];  // Acessa o primeiro elemento
        console.log("firstTeacher", firstTeacher);
        setTeacherName(firstTeacher);  // Define apenas o primeiro elemento
      }
      if (resGrade && resGrade.data && Array.isArray(resGrade.data.data) && resGrade.data.data.length > 0) {
        const res = resGrade.data.data[0]; // Pega o primeiro item do array

        if (res && res.id_iiiRdQuarter) {

          console.log('totalGrade', res.id_iiiRdQuarter.totalGrade)
          console.log('averageGrade', res.id_iiiRdQuarter.averageGrade)

          const tg = res.id_iiiRdQuarter.totalGrade
          const ag = res.id_iiiRdQuarter.averageGrade

          setTotalGrade(tg)
          setAverageGrade(ag)


          let startd = res.id_iiiRdQuarter.startday || null;
          let startm = res.id_iiiRdQuarter.startmonth || null;
          let starty = res.id_iiiRdQuarter.startyear || null;

          let endd = res.id_iiiRdQuarter.endday || null;
          let endm = res.id_iiiRdQuarter.endmonth || null;
          let endy = res.id_iiiRdQuarter.endyear || null;

          // Atualiza os estados apenas se os valores forem válidos
          setStartd(startd);
          setStartm(startm);
          setStarty(starty);

          setEndd(endd);
          setEndm(endm);
          setEndy(endy);
        } else {
          console.error("Dados de id_iStQuarter estão faltando ou incompletos");
        }
      } else {
        console.error("resGrade está vazio ou malformado");
      }
      const cachedLogo = localStorage.getItem(`school-logo-${idSchool}`);
      //const cachedLogoId = localStorage.getItem(`school-logo-id-${idSchool}`);

      if (cachedLogo) {
        console.log('busca pelo storage local')
        setLogoUrl(cachedLogo);
        //setlogoId(cachedLogoId);
      } else {

        console.log('busca no s3')
        const logoRes = await fetchLogo(idSchool);

        console.log('busca logo', logoRes)
        if (logoRes?.url) {
          setLogoUrl(logoRes.url);
          //setlogoId(logoRes._id);
          localStorage.setItem(`school-logo-${idSchool}`, logoRes.url);
          localStorage.setItem(`school-logo-id-${idSchool}`, logoRes._id);

        }
      }
      setLoading(false);
    })();

  }, [startd, startm, starty, endd, endm, endy, idClass]);

  useEffect(() => {
    const fetchAttendance = async () => {
      if (startd && startm && starty && endd && endm && endy && id_student && id_teacher) {
        try {
          const result = await AttendanceBimonthly(startd, startm, starty, endd, endm, endy, id_student, id_teacher);
          const data = result?.data?.data || [];

          if (data.length > 0) {
            const attendance = data.filter(res => res.status === "P");
            const attendancef = data.filter(res => res.status === "F");
            const attendancefj = data.filter(res => res.status === "FJ");

            setHighlightedDays(attendance.length ? attendance : []);
            setHighlightedDaysF(attendancef.length ? attendancef : []);
            setHighlightedDaysFJ(attendancefj.length ? attendancefj : []);
          } else {
            console.warn("Nenhum dado de frequência disponível.");
          }
        } catch (error) {
          console.error("Erro ao obter dados de frequência", error);
        }
      }
    };

    fetchAttendance();
  }, [startd, startm, starty, endd, endm, endy, id_student, id_teacher]);


  console.log("startd", startd);
  console.log("startm", startm);
  console.log("starty", starty);
  console.log("endd", endd);
  console.log("endm", endm);
  console.log("endy", endy);

  const messageButtonClick = () => {
    navigate(-1);
  };

  const handlePrint = () => {
    window.print();
  };

  const countPresences = highlightedDays.length;
  const countAbsences = highlightedDaysF.length;
  const countjustifiedAbsence = highlightedDaysFJ.length;

  const groupedGrades = grade.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(grd.studentGrade) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const groupedGradesIst = iStQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(grd.studentGrade) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const groupedGradesIInd = iiNdQuarter.reduce((acc, grd) => {
    // Verifica se a matéria já existe no acumulador
    const existingMatter = acc.find(item => item.id_matter === grd.id_matter._id);

    if (!existingMatter) {
      // Se a matéria não existir no acumulador, adicionamos ela
      acc.push({
        idActivity: grd.idActivity,
        id_matter: grd.id_matter._id,
        matterName: grd.id_matter.name,
        grade: 0,  // Inicializa a soma das notas
      });
    }

    // Somando as notas, garantindo que sejam números (usando parseFloat)
    const totalGradeForMatter = parseFloat(grd.studentGrade) || 0;

    // Atualiza a soma das notas para a matéria no acumulador
    const updatedMatter = acc.find(item => item.id_matter === grd.id_matter._id);
    if (updatedMatter) {
      updatedMatter.grade += totalGradeForMatter;
    }

    return acc;
  }, []);

  const periodLabel = assessmentRegime === 'TRIMESTRAL' ? 'TRIM' : 'BIM';

  return (
    <Container>
      <GlobalStyle /> {/* Adicionando estilos globais */}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <ContainerDivs>
            <div className="no-print">
              <h3>Atenção antes de imprimir</h3>
              <p>
                Caso o boletim possua muitas matérias e não caiba totalmente em uma única folha,
                diminua a <strong>escala de impressão</strong> nas configurações da impressora.
                Sugestão: <strong>90%</strong>, <strong>85%</strong> ou <strong>80%</strong>.
              </p>
            </div>
            {
              logo.length > 0 && (
                <img src={logo} alt="Imagem" />
              )
            }

            <PrintButton className="no-print" onClick={handlePrint}>
              Imprimir
            </PrintButton>
            <DivAddEmp id="containerDivs">
              <ContLogo>
                {(logoUrl) && (
                  <Preview src={logoUrl} alt="Logo da escola" />
                )}
                <h2>Boletim</h2>
              </ContLogo>
              <AddEmp>
                {assessmentRegime === 'BIMESTRAL' && (
                  <h3>3º Bimestre</h3>
                )}
                {assessmentRegime === 'TRIMESTRAL' && (
                  <h3>3º Trimestre</h3>
                )}
              </AddEmp>
              <DadosStdt>
                <UpContainer>
                  <InfoContainer>
                    <span><strong>Escola:</strong> {nameSchool}</span>
                    <span>
                      <strong>Série:</strong> {dataCla$$?.data?.data?.[0]?.serie} - {dataCla$$?.data.data?.[0]?.level}
                    </span>

                    <span>
                      <strong>Turma:</strong> {dataCla$$?.data?.data?.[0]?.name}
                    </span>

                    <span>
                      <strong>Ano Letivo:</strong> {dataCla$$?.data?.data?.[0]?.year}
                    </span>
                    <span><strong>Professor(a):</strong> {teacherName}</span>
                    <span><strong>Aluno(a):</strong> {stdtName}</span>
                  </InfoContainer>
                  <SpanFrequency>
                    <span><IoCheckmarkSharp color='#00fa00' font-size="30px" />Presenças: {countPresences} | <IoCloseSharp color='#ff050a' font-size="30px" />Faltas: {countAbsences}</span>
                    <span><FcSurvey font-size="25px" />Faltas Justificadas: {countjustifiedAbsence}</span>
                  </SpanFrequency>
                </UpContainer>
                <LegendaNotas total={parseFloat(totalGrade).toFixed(1)} media={parseFloat(averageGrade).toFixed(1)} totalLabel="Total" mediaLabel="Média" />
              </DadosStdt>
              <DivDados>
                <List>
                  {
                    groupedGrades
                      .sort((a, b) => {
                        // ordena conforme a ordem definida pelo usuário (campo
                        // `order` vindo do GetMatter), com a Educação Física no fim
                        const norm = (s = '') => s.trim().toUpperCase();
                        const orderIndex = new Map((matters || []).map((m, i) => [norm(m.name), i]));
                        const big = Number.MAX_SAFE_INTEGER;
                        const ia = orderIndex.has(norm(a.matterName)) ? orderIndex.get(norm(a.matterName)) : big;
                        const ib = orderIndex.has(norm(b.matterName)) ? orderIndex.get(norm(b.matterName)) : big;
                        return ia - ib;
                      })
                      .map(grd => (
                        <Emp
                          key={grd._id} >
                          <DivNameMatter>
                            <SpanNameMatter>{grd.matterName}</SpanNameMatter>
                          </DivNameMatter>
                          <Grade>
                            <DivBimTable>
                              <DivBimRow>
                                <DivBimHeader>1º {periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={
                                    groupedGradesIst.find(res => String(res.id_matter) === String(grd.id_matter))?.grade || 0
                                  }
                                  averageGrade={parseFloat(averageGradeIst) || 0}
                                  totalGrade={parseFloat(totalGradeIst) || 0}
                                >
                                  {groupedGradesIst
                                    .filter(res => String(res.id_matter) === String(grd.id_matter))
                                    .map(res => {
                                      const gradeValue = parseFloat(res.grade?.toString().replace(',', '.'));
                                      const isHistory = !res.idActivity;
                                      if (isNaN(gradeValue)) return "-";

                                      return (
                                        <span
                                          key={res._id}
                                          style={{ color: isHistory ? '#7A6F9B' : 'inherit' }}
                                        >
                                          <NotaComRec nota={gradeValue} rec={recFinal(1, null, grd.matterName, gradeValue, averageGradeIst)} />
                                        </span>
                                      )
                                    })}
                                </DivBimCell>
                              </DivBimRow>
                              <DivBimRow>
                                <DivBimHeader>2º {periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={
                                    groupedGradesIInd.find(res => String(res.id_matter) === String(grd.id_matter))?.grade || 0
                                  }
                                  averageGrade={parseFloat(averageGradeIInd) || 0}
                                  totalGrade={parseFloat(totalGradeIInd) || 0}
                                >
                                  {groupedGradesIInd
                                    .filter(res => String(res.id_matter) === String(grd.id_matter))
                                    .map(res => {
                                      const gradeValue = parseFloat(res.grade?.toString().replace(',', '.'));
                                      const isHistory = !res.idActivity;
                                      if (isNaN(gradeValue)) return "-";

                                      return (
                                        <span
                                          key={res._id}
                                          style={{ color: isHistory ? '#7A6F9B' : 'inherit' }}
                                        >
                                          <NotaComRec nota={gradeValue} rec={recFinal(2, null, grd.matterName, gradeValue, averageGradeIInd)} />
                                        </span>
                                      )
                                    })}
                                </DivBimCell>
                              </DivBimRow>
                              <DivBimRow>
                                <DivBimHeader>3º {periodLabel}</DivBimHeader>
                                <DivBimCell
                                  grade={parseFloat(grd.grade) || 0}  // Garantir que é um número válido, senão 0
                                  averageGrade={parseFloat(averageGrade) || 0}  // Garantir que a média é válida
                                  totalGrade={parseFloat(totalGrade) || 0}  // Garantir que o total é válido
                                >
                                  {grd.grade !== undefined && grd.grade !== null ? (
                                    <span style={{ color: !grd.idActivity ? '#7A6F9B' : 'inherit' }}>
                                      <NotaComRec nota={grd.grade} rec={recFinal(3, null, grd.matterName, parseFloat(grd.grade) || 0, averageGrade)} />
                                    </span>
                                  ) : (
                                    "-"
                                  )}
                                </DivBimCell>
                              </DivBimRow>
                              {assessmentRegime !== 'TRIMESTRAL' && (
                                <DivBimRow>
                                  <DivBimHeader>4º {periodLabel}</DivBimHeader>
                                  <DivBimCell /*grade={ivThQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade || "N/A"}*/>
                                    {/*ivThQuarter.find((q) => q.id_matter === grd.id_matter._id)?.studentGrade ||*/ "-"}
                                  </DivBimCell>
                                </DivBimRow>
                              )}
                            </DivBimTable>
                            {/*<SpanTotalGrade><p>Total</p>{grd.totalGrade}</SpanTotalGrade>
                          <SpanAverageGrade><p>Media</p>{grd.averageGrade}</SpanAverageGrade>*/}
                            {/*<SpanGradeStudent grade={grd.studentGrade} /*average={grd.averageGrade}><p>Desempenho</p>{grd.studentGrade}</SpanGradeStudent>*/}
                          </Grade>
                        </Emp>
                      ))
                  }
                </List>
              </DivDados>
              {/* Espaço para assinatura do Professor e dos Pais */}
              <DivSignatureArea>
                <SignatureBlock>
                  <Line />
                  <Label>Assinatura do Professor</Label>
                </SignatureBlock>

                <SignatureBlock>
                  <Line />
                  <Label>Assinatura dos Pais ou Responsável</Label>
                </SignatureBlock>
              </DivSignatureArea>
            </DivAddEmp>
          </ContainerDivs>
          <ToGoBack onClick={messageButtonClick}>
            <SignMessageButtonText>Voltar para o</SignMessageButtonText>
            <SignMessageButtonTextBold>Perfil do Aluno</SignMessageButtonTextBold>
          </ToGoBack>
        </>
      )}
    </Container>
  )
}

export default GradeIstquarter